import { cx } from "class-variance-authority";

// NO TESTS FOR THIS UTIL
// We'd essentially be testing class-variance-authority and tailwind-merge
// We're not adding any logic to these libraries.

/**
 * Merges classes with user exceptions prioritized
 * so that user exceptions can override the default
 * @param inputs the classes to merge
 * @returns the merged classes with user exceptions prioritized
 */
export function cn(...inputs: (string | undefined)[]) {
  return cx(inputs);
}
